<mat-card class="height-100">
  <mat-card-header>
    <mat-card-title>
      {{entity.id ? 'Editar' : 'Adicionar'}} cliente
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Dados" style="flex: 1;">
        <ng-template mat-tab-label>
          Dados
          <i
            *ngIf="formDadosValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>
        <!-- CPF/CNPJ e INSC. EST. / RG -->
        <div class="flex width-100">
          <div class="flex-column mt-2 col-md-12">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>CPF/CNPJ </mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('cpf_cnpj')"
                mask="000.000.000-00||00.000.000/0000-00"
                (blur)="checkCpfCnpj()"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('repeated')
              "
            >
              {{ messages.cpf_cnpj.repeated }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('required')
              "
            >
              {{ messages.cpf_cnpj.required }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('pattern')
              "
            >
              {{ messages.cpf_cnpj.pattern }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('duplicate')
              "
            >
              {{ messages.cpf_cnpj.duplicate }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('maxlength')
              "
            >
              {{ messages.cpf_cnpj.maxlength }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('validateCPF')
              "
            >
              {{ messages.cpf_cnpj.validateCPF }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('validateCNPJ')
              "
            >
              {{ messages.cpf_cnpj.validateCNPJ }}
            </small>
          </div>
        </div>
        <!-- NOME -->
        <div class="flex-column mt-2 col-md-12">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>Nome/razão social </mat-label>
            <input
              matInput
              type="text"
              [formControl]="form.get('nome_razao_social')"
            />
          </mat-form-field>

          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('required')
            "
          >
            {{ messages.nome_razao_social.required }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('maxlength')
            "
          >
            {{ messages.nome_razao_social.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('minlength')
            "
          >
            {{ messages.nome_razao_social.minlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('nome_razao_social').touched &&
              form.get('nome_razao_social').hasError('isEmptyValue')
            "
          >
            {{ messages.nome_razao_social.isEmptyValue }}
          </small>
        </div>
        <!-- APELIDO -->
        <div class="flex-column mt-2 col-md-12">
          <mat-form-field class="width-100" appearance="outline">
            <mat-label>Apelido/nome fantasia</mat-label>
            <input
              matInput
              type="text"
              [formControl]="form.get('apelido_nome_fantasia')"
            />
          </mat-form-field>
          <small
            class="p-error"
            *ngIf="
              form.get('apelido_nome_fantasia').touched &&
              form.get('apelido_nome_fantasia').hasError('maxlength')
            "
          >
            {{ messages.apelido_nome_fantasia.maxlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('apelido_nome_fantasia').touched &&
              form.get('apelido_nome_fantasia').hasError('minlength')
            "
          >
            {{ messages.apelido_nome_fantasia.minlength }}
          </small>
          <small
            class="p-error"
            *ngIf="
              form.get('apelido_nome_fantasia').touched &&
              form.get('apelido_nome_fantasia').hasError('isEmptyValue')
            "
          >
            {{ messages.apelido_nome_fantasia.isEmptyValue }}
          </small>
        </div>
        <!-- INSC. EST. / RG - INSC. MUNC. -->
        <div class="flex width-100">
          <div
            [class]="
              usa_fiscal ? 'flex-column mt-2 col-md-6' : 'flex-column mt-2 col-md-12'
            "
          >
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Inscrição estadual</mat-label>
              <input
                matInput
                (keydown)="notText($event)"
                (blur)="checkRgInscEstadual()"
                type="text"
                [formControl]="form.get('rg_insc_est')"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="form.get('rg_insc_est').hasError('pattern')"
            >
              {{ messages.rg_insc_est.pattern }}
            </small>
            <small
              class="p-error"
              *ngIf="form.get('rg_insc_est').hasError('maxlength')"
            >
              {{ messages.rg_insc_est.maxlength }}
            </small>
            <small
              class="p-error"
              *ngIf="form.get('rg_insc_est').hasError('existSpecialChar')"
            >
              {{ messages.rg_insc_est.existSpecialChar }}
            </small>
            <small
              class="p-error"
              *ngIf="form.get('rg_insc_est').hasError('isEmptyValue')"
            >
              {{ messages.rg_insc_est.isEmptyValue }}
            </small>
          </div>
          <div class="flex-column mt-2 col-md-6" *ngIf="usa_fiscal">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Inscrição Municipal</mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('insc_mun')"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="form.get('insc_mun').hasError('maxlength')"
            >
              {{ messages.insc_mun.maxlength }}
            </small>
          </div>
        </div>

        <div class="flex width-100">
          <div
            [class]="
              usa_fiscal ? 'flex-column mt-2 col-md-6' : 'flex-column mt-2 col-md-12'
            "
          >
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Data de nascimento</mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('data_nascimento')"
                [matDatepicker]="picker"
                fastFormatData
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <small
              class="p-error"
              *ngIf="
                form.get('data_nascimento').touched &&
                form.get('data_nascimento').hasError('matDatepickerParse')
              "
            >
              Essa data é inválida
            </small>
            <small
              class="p-error"
              id="error-data-nascimento"
              *ngIf="form.get('data_nascimento').touched &&
              form.get('data_nascimento').hasError('invalidDate')"
            >
              Data não pode ser posterior a atual
            </small>
          </div>

          <div
            class="mt-2 col-md-6"
            *ngIf="
              usa_fiscal &&
              form.get('rg_insc_est').value &&
              form.get('rg_insc_est').valid
            "
          >
            <mat-form-field style="width: 100% !important;" appearance="outline">
              <mat-label>Tipo contribuinte</mat-label>
              <mat-select [formControl]="form.controls.tipo_contribuinte">
                <mat-option
                  *ngFor="let i of contribuinteOptions"
                  [value]="i.value"
                  >{{ i.viewValue }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
          <div
            class="mt-2 col-md-6"
            *ngIf="
              usa_fiscal &&
              !(form.get('rg_insc_est').value && form.get('rg_insc_est').valid)
            "
          >
            <mat-form-field style="width: 100% !important;" appearance="outline">
              <mat-label>Tipo contribuinte</mat-label>
              <mat-select [formControl]="form.controls.tipo_contribuinte">
                <mat-option *ngFor="let i of isentoOptions" [value]="i.value">{{
                  i.viewValue
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="mt-2 col-md-12">
          <fav-cond-pagto
            #input
            [autoFirst]="false"
            [control]="form.get('cond_pagto')"
            [cliente_id]="entity.id"
            [domain_id]="tokenService.getDomain().id"
            displayField="descricao"
            placeholder="Condição de pagamento padrão"
            [value_order]="'descricao'"
            [initDataWithEmpty]="entity.id ? true : false"
            [notShowResultsFirst]="false"
            autocomplete="off"
            [messages]="{
              typeIs: 'Valor inválido',
              isEmptyValue: 'Valor inválido: remova os espaços em branco'
            }"
            [pageValue]="'0'"
            [pageSizeValue]="'10'"
          ></fav-cond-pagto>
        </div>
        <div class="flex width-100" *ngIf="usa_fiscal">
          <div class="mt-2 col-md-6" style="margin-top: 25px;">
            <span class="p-float-label">
              <input
                type="text"
                id="inputtext-right"
                pInputText
                type="text"
                [formControl]="form.get('doc_estrangeiro')"
                class="input-filters"
              />
              <label for="inputtext-right">Doc. estrangeiro</label>
            </span>
            <small
              class="p-error"
              *ngIf="
                form.get('doc_estrangeiro').touched &&
                form.get('doc_estrangeiro').hasError('maxlength')
              "
            >
              {{ messages.doc_estrangeiro.maxlength }}
            </small>
          </div>

          <div class="mt-2 col-md-6 mt-2">
            <div
              *ngIf="autorizados"
              class="font-weight-light text-right width-100"
            >
              <span
                [matMenuTriggerFor]="
                  autorizados.length !== 0 ? menuFilter : null
                "
                [class]="autorizados.length !== 0 ? 'cursor-pointer' : ''"
              >
                Autorizados: {{ autorizados.length }}
              </span>
              <mat-menu #menuFilter="matMenu" class="text-center menu-content">
                <div class="content-itens-filter">
                  <span style="font-weight: bold;">Autorizados</span>
                  <div class="my-2" *ngFor="let value of autorizados">
                    <span>
                      <b>CPF/CNPJ:</b>
                      {{
                        cpfCnpjPipe.transform(value.cpf_cnpj) ||
                          cpfCnpjPipe.transform(value)
                      }}
                    </span>
                  </div>
                </div>
              </mat-menu>
            </div>
            <div class="flex width-100">
              <span class="p-float-label width-100">
                <input
                  type="text"
                  id="inputtext-right"
                  pInputText
                  type="text"
                  [formControl]="form.get('cpf_cnpj_autorizado')"
                  [mask]="'000.000.000-00||00.000.000/0000-00'"
                  class="input-filters no-border-radius"
                />
                <label for="inputtext-right">CPF/CNPJ de autorizados</label>
              </span>
              <button
                type="button"
                class="button-radius"
                pButton
                pRipple
                icon="pi pi-plus-circle"
                [disabled]="!form.value.cpf_cnpj_autorizado"
                (click)="enterPress()"
              ></button>
            </div>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj_autorizado').touched &&
                form.get('cpf_cnpj_autorizado').hasError('maxlength')
              "
            >
              {{ messages.cpf_cnpj_autorizado.maxlength }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj_autorizado').touched &&
                form.get('cpf_cnpj_autorizado').hasError('validateCPF')
              "
            >
              {{ messages.cpf_cnpj_autorizado.validateCPF }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj_autorizado').touched &&
                form.get('cpf_cnpj_autorizado').hasError('validateCNPJ')
              "
            >
              {{ messages.cpf_cnpj_autorizado.validateCNPJ }}
            </small>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Endereço" style="flex: 1;">
        <ng-template mat-tab-label>
          Endereço
          <i
            *ngIf="formAddressValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>
        <app-fast-endereco
          [entity]="entity.parceiro"
          [showCodPais]="usa_fiscal"
          [insertDocEstrangeiro]="insertDocEstrangeiro"
        ></app-fast-endereco>
      </mat-tab>
      <mat-tab label="Contatos">
        <app-fast-contato [entity]="entity.parceiro"></app-fast-contato>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
  <mat-card-actions>
    <div class="mt-2 col-md-12 mt-2 flex justify-content-between">
      <button mat-stroked-button color="warn" [matDialogClose]="undefined">
        Cancelar
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="onSubmit()"
        [disabled]="!formValid"
      >
        {{entity.id ? 'Atualizar' : 'Cadastrar'}}
      </button>
    </div>
  </mat-card-actions>
</mat-card>
